import IconButton from "@mui/material/IconButton";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";

export const columns = (handleDelete, handleGiveBack) => [
  {
    field: "categoryName",
    headerName: "Kategori Adı",
    sortable: false,
    filterable: false,
    flex: 1,
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "brandName",
    headerName: "Marka Adı",
    sortable: false,
    filterable: false,
    flex: 1,
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "modelName",
    headerName: "Model Adı",
    sortable: false,
    filterable: false,
    flex: 1,
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "serialNumber",
    headerName: "Seri Numarası",
    sortable: false,
    filterable: false,
    flex: 1,
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "firstName",
    headerName: "Kullanıcı Adı",
    sortable: false,
    filterable: false,
    flex: 1,
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "lastName",
    headerName: "Kullanıcı Soyadı",
    sortable: false,
    filterable: false,
    flex: 1,
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "insuranceDate",
    headerName: "Zimmet Edilme Tarihi",
    sortable: false,
    filterable: false,
    flex: 1,
    valueGetter: (value, row) =>
      row &&
      row.insuranceDate &&
      moment(row.insuranceDate).format("DD/MM/YYYY"),
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "giveBackDate",
    headerName: "İade Tarihi",
    sortable: false,
    filterable: false,
    flex: 1,
    valueGetter: (value, row) =>
      row && row.giveBackDate && moment(row.giveBackDate).format("DD/MM/YYYY"),
    renderCell: (params) => (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {params.value}
      </div>
    ),
  },
  {
    field: "actions",
    headerName: "İşlemler",
    flex: 1,
    minWidth: 150,
    sortable: false,
    filterable: false,
    disableExport: true,
    renderCell: (params) => (
      <div style={{ display: "flex", gap: 8, marginTop: 5 }}>
        <IconButton
          variant="contained"
          color="secondary"
          onClick={() => handleGiveBack(params.row)}
        >
          <EditCalendarIcon />
        </IconButton>
        <IconButton
          variant="contained"
          color="error"
          onClick={() => handleDelete(params.row)}
        >
          <DeleteIcon />
        </IconButton>
      </div>
    ),
  },
];
